"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstItem = getFirstItem;
exports.iteratorFor = iteratorFor;
var done = {};
/**
 * Gets the first element of the iterable.
 */

function getFirstItem(iterable) {
  var iterator = iterable[Symbol.asyncIterator]();
  return iterator.next().then(function (item) {
    return item.value;
  });
}
/**
 * Creates an async iterator with the item as only element.
 */


function iteratorFor(item) {
  return {
    next: function () {
      var _next = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(item !== done)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return item;

              case 3:
                value = _context.sent;
                item = done;
                return _context.abrupt("return", {
                  value: value
                });

              case 6:
                return _context.abrupt("return", {
                  done: true
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function next() {
        return _next.apply(this, arguments);
      }

      return next;
    }()
  };
}